<template>
  <v-card class="pb-0">

    <!-- Navigation Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      >
      <v-list dense>
        <template v-for="(item, index) in menuItems">
          <template v-if="menuIsAuthorized(item)">
            <v-divider
              v-if="item.prefixWithDivider"
              :key="`divider-${index}`"
            />
            <v-list-item
              :key="index"
              @click="menuAction(index)"
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>{{ item.text }}</v-list-item-content>
            </v-list-item>
          </template>
        </template>
        <v-divider />
        <template v-if="authenticated">
          <!-- <v-list-item @click="editProfile">
            <v-list-item-action>
              <v-icon>person</v-icon>
            </v-list-item-action>
            <v-list-item-content>Edit Profile</v-list-item-content>
          </v-list-item> -->
          <v-list-item @click="signOut">
            <v-list-item-action>
              <v-icon>power_settings_new</v-icon>
            </v-list-item-action>
            <v-list-item-content>Sign Out</v-list-item-content>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-item @click="$router.push('/bullFinderLite')">
            <v-list-item-action>
              <v-icon>highlight</v-icon>
            </v-list-item-action>
            <v-list-item-content>Bull Finder Lite</v-list-item-content>
          </v-list-item>
          <v-list-item @click="login">
            <v-list-item-action>
              <v-icon>lock_open</v-icon>
            </v-list-item-action>
            <v-list-item-content>Sign In</v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- Appbar -->
    <v-app-bar
      v-if="!hideToolbar"
      app
      dark
      :color="appColor_Dark"
      >

      <!-- Hamburger -->
      <v-app-bar-nav-icon
        :disabled="drawerDisabled"
        @click.stop="drawer = !drawer"
      />

      <!-- Title -->
      <router-link class="white--text home-banner" to="/" exact>
        <v-toolbar-title :class="isSmallDevice ? 'body-1' : 'title ml-2'">
          Cattlytics
        </v-toolbar-title>
      </router-link>

      <v-spacer />

      <template v-if="authenticated && isAdminy">
        <v-chip v-if="appSettings.isSaleDayMode" small color="deep-orange darken-3" class="mr-4 ml-1">
          {{ !isSmallDevice ? 'Sale Day Mode' : null }}
        </v-chip>
      </template>

      <!-- Performance Data -->
      <v-btn icon small @click="perfDataDialog = true" class="mr-4">
        <v-icon :color="appColor_IconInfo">info</v-icon>
      </v-btn>

      <!-- Help -->
      <v-btn icon small to="/help" class="mr-4">
        <v-icon :color="appColor_IconHelp">help</v-icon>
      </v-btn>

      <!-- Authenticated -->
      <template v-if="authenticated">

        <!-- Beefbooster Certified -->
        <v-chip
          v-if="isBeefboosterValid && !isSmallDevice"
          light
          small
          dark
          :color="appColor_ChipBeefbooster"
          :class="isSmallDevice ? 'mr-1' : 'mr-4 elevation-1'"
          >
          {{ isSmallDevice ? 'BB' : 'Beefbooster' }}
        </v-chip>

        <!-- Herdtrax Certified -->
        <v-chip
          v-if="isHerdtraxValid && !isSmallDevice"
          light
          small
          dark
          :color="appColor_ChipHerdtrax"
          :class="isSmallDevice ? 'mr-1' : 'mr-4 elevation-1'"
          >
          {{ isSmallDevice ? 'HX' : 'Herdtrax' }}
        </v-chip>

        <!-- Proile Menu -->
        <v-toolbar-items>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
              small
                :color="appColor_Dark"
                v-on="on"
                class="elevation-0 pr-0"
                >
                <v-avatar size="50">
                  <img :src="profile.picture" class="outlined">
                </v-avatar>
                <v-icon class="pl-1">
                  arrow_drop_down
                </v-icon>
              </v-btn>
            </template>
            <v-list
              v-if="profile"
              dense
              >
              <v-list-item>
                <v-list-item-title class="font-weight-medium">
                  {{ profile.name }}
                </v-list-item-title>
              </v-list-item>
              <v-divider />
              <v-list-item
                class="pb-0"
                @click="editProfile"
                >
                <v-list-item-avatar>
                  <v-icon color="blue darken-2">person</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>
                  Edit Profile
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                class="pb-0"
                @click="profilePasswordDialog = true"
                >
                <v-list-item-avatar>
                  <v-icon>security</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Change Password</v-list-item-title>
              </v-list-item>
              <v-divider />
              <v-list-item @click="logout">
                <v-list-item-avatar>
                  <v-icon>power_settings_new</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Sign Out</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </template>

      <!-- Not Authenticated -->
      <template v-else>
        <v-toolbar-items>
          <v-btn
            :color="appColor_Dark"
            @click="login"
            >
            Sign In
          </v-btn>
        </v-toolbar-items>
      </template>
    </v-app-bar>

    <!-- Profile Edit Dialog -->
    <v-dialog
      v-model="profileEditDialog"
      max-width="480px"
      :persistent="true"
      >
      <profile-edit
        :profile="profileModel"
        @save="profileSave"
        @cancel="profileEditDialog = false"
        @error="showError"
      />
    </v-dialog>

    <!-- Profile Password Dialog -->
    <v-dialog
      v-model="profilePasswordDialog"
      max-width="300px"
      :persistent="true"
      >
      <profile-password
        :user-id="profile.id"
        @close="profilePasswordDialog = false"
      />
    </v-dialog>

    <!-- Performance Data Dialog -->
    <v-layout row justify-center>
      <v-dialog max-width="600px" v-model="perfDataDialog">
        <performance-data
          v-on:close="perfDataDialog = false">
        </performance-data>
      </v-dialog>
    </v-layout>
    
    <!-- Error Dialog -->
    <v-dialog
      v-model="errorDialog"
      max-width="400px"
      >
      <app-error
        :error-title="errorTitle"
        :error-text="errorText"
        @close="errorDialog = false"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import AppError from '@/components/AppError'
import ProfileEdit from '@/components/ProfileEdit'
import ProfilePassword from '@/components/ProfilePassword'
import PerformanceData from '@/components/PerformanceData'
import { mapActions, mapGetters } from 'vuex'
import { AppColor } from '@/config.js'

export default {
  name: 'AppToolbar',
  components: {
    AppError,
    ProfileEdit,
    ProfilePassword,
    PerformanceData
  },
  data: () => ({
    appColor_Light: AppColor.Light,
    appColor_Dark: AppColor.Dark,
    appColor_ChipBeefbooster: AppColor.ChipBeefbooster,
    appColor_ChipHerdtrax: AppColor.ChipHerdtrax,
    appColor_IconHelp: AppColor.IconHelp,
    appColor_IconInfo: AppColor.IconInfo,

    drawer: null,
    profilePasswordDialog: false,
    profileEditDialog: false,
    perfDataDialog: false,
    profileModel: {
      id: null,
      email: null,
      name: null,
      nickname: null,
      picture: '',
      companyName: null
    },

    // error handling
    errorDialog: false,
    errorTitle: 'Internal Error',
    errorText: null
  }),
  computed: {
    ...mapGetters(['authenticated', 'profile', 'appSettings']),
    menuItems () {
      var menuItems = []
      menuItems.push(
        {
          text: 'Home',
          action: '/',
          icon: 'home',
          noAuthRequired: true
        })
        menuItems.push({
          text: 'Herd Profile',
          action: '/herdProfile',
          icon: 'multiline_chart',
          prefixWithDivider: true
        })
        menuItems.push({
          text: 'Herd Sort',
          action: '/herdSort',
          icon: 'sort'
        })
        menuItems.push({
          text: 'Bull Finder',
          action: '/bullFinder',
          icon: 'highlight'
        })
        menuItems.push({
          text: 'Favorite Bulls',
          action: '/favoriteBulls',
          icon: 'favorite',
          prefixWithDivider: true
        })
        menuItems.push({
          text: 'Herd Sort Queries',
          action: '/herdSortManager',
          icon: 'query_builder'
        })
        menuItems.push({
          text: 'Bull Finder Queries',
          action: '/bullFinderManager',
          icon: 'query_builder'
        })
        menuItems.push({
          text: 'Photo Gallery',
          action: '/photoViewer',
          icon: 'photo_camera'
        })
        menuItems.push({
          text: 'Video Gallery',
          action: '/videoViewer',
          icon: 'videocam'
        })
        menuItems.push({
          text: 'Invoice History',
          action: '/bbCustomerInvoices',
          icon: 'receipt',
          isBeefbooster: true
        })
        
        // admin items
        menuItems.push({
          text: 'Users',
          action: '/userManager',
          icon: 'people',
          prefixWithDivider: true,
          isAdmin: true
        })
        menuItems.push({
          text: 'Gallery Media',
          action: '/mediaManager',
          icon: 'perm_media',
          isAdmin: true
        })
        menuItems.push({
          text: 'Animal Sources',
          action: '/animalSourceManager',
          icon: 'color_lens',
          isAdmin: true
        })
        menuItems.push({
          text: 'Herdtrax Assistant',
          action: '/herdtraxAssistant',
          icon: 'assistant',
          isAdmin: true
        })
        menuItems.push({
          text: 'App Settings',
          action: '/appSettings',
          icon: 'settings',
          isAdmin: true
        })
      return menuItems
    },
    drawerDisabled () {
      if (this.$route.name === 'Home') return false
      return this.$route.meta.parentRoute !== '/'
    },
    isAdmin () {
      return !this.isNullOrUndefined(this.profile.roles)
        ? this.profile.roles.includes('Admin')
        : false
    },
    isBreeder () {
      return !this.isNullOrUndefined(this.profile.roles)
        ? this.profile.roles.includes('Breeder')
        : false
    },
    isAdminy () {
      return this.isAdmin || this.isBreeder
    },
    isBeefboosterValid () {
      if (this.isNullOrUndefined(this.profile.bbCustomerStatus))
        return false

      return !this.isNullOrUndefined(this.profile.bbCustomerStatus)
          ? this.profile.isBeefboosterCustomer && this.profile.bbCustomerStatus.isValid
          : false
    },
    isHerdtraxValid () {
      if (this.isNullOrUndefined(this.profile.hxCustomerStatus))
        return false

      return !this.isNullOrUndefined(this.profile.hxCustomerStatus)
          ? this.profile.isBeefboosterCustomer && this.profile.hxCustomerStatus.isValid
          : false
    },
    currentPath () {
      return this.$route.path
    },
    hideToolbar () {
      return (this.$route.name === 'Logout')
    },
    isSmallDevice () {
      return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm'
    }
  },
  methods: {
    ...mapActions(['login', 'logout']),
    signOut () {
      this.drawer = false
      this.logout()
    },

    menuAction (index) {
      this.drawer = false
      this.$router.push(this.menuItems[index].action).catch(() => {})
    },

    menuIsAuthorized (menuItem) {
      if (menuItem.noAuthRequired) return true

      if (menuItem.isAdmin) {
        return this.hasRole('Admin')
      } else {
        if (!this.authenticated) return false

        if (menuItem.isBeefbooster) {
          return this.isBeefboosterValid
        }
        if (menuItem.isHerdtrax) {
          return this.isHerdtraxValid
        }
      }
      return true
    },

    hasRole (role) {
      if (this.profile.roles === undefined) return false
      return this.profile.roles.includes(role)
    },

    showError ({ errorMessage }) {
      this.errorText = errorMessage
      this.errorDialog = true
    },

    editProfile () {
      const self = this
      self.profileModel = {
        id: self.profile.id,
        email: self.profile.email,
        name: self.profile.name,
        nickname: self.profile.nickname,
        picture: self.profile.picture,
        companyName: self.profile.companyName,
        phone1: self.profile.phone1,
        phone2: self.profile.phone2,
        cowHerdSize: self.profile.cowHerdSize != null
          ? parseInt(self.profile.cowHerdSize)
          : null,
        isBeefboosterCustomer: self.profile.isBeefboosterCustomer,
        isHerdtraxCustomer: self.profile.isHerdtraxCustomer,
        isBeefboosterValid: self.isBeefboosterValid,
        isHerdtraxValid: self.isHerdtraxValid,
        bullPreferences: self.profile.bullPreferences,
        isAdminy: self.isAdminy
      },
      self.profileEditDialog = true
    },

    profileSave () {
      this.profileEditDialog = false
      this.$store.dispatch('updateProfile', { profile: this.profileModel })
    },

    isNullOrUndefined (obj) {
      return obj === undefined 
        || typeof obj === 'undefined' 
        || obj === null
    }
  }
}
</script>

<style scoped>
.home-banner {
  text-decoration: none;
}
.outlined {
    border: 2px solid #bbb;
    border-radius:50%;
}
</style>
